module.exports = __webpack_public_path__ + "public/files/img/phone-call.b7e62667.png";